import { Box } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import ModularSideBar from '../../components/SideBar/ModularSideBar'
import AIActNotice from '../../components/_shared/AIActNotice'
import LegalConsentNotice from '../../components/_shared/LegalConsentNotice'

export default function DashboardLayout() {
  return (
    <Box display={'flex'} h={'100vh'} overflow="hidden">
      <Box
        height="100%"
        flexShrink={0}
        // Aurora glow (purple + a touch of cyan) layered over the dark gradient,
        // for depth instead of a flat panel.
        style={{
          background:
            'radial-gradient(130% 55% at 50% -8%, rgba(167,139,250,0.20), transparent 60%),' +
            'radial-gradient(90% 45% at 100% 8%, rgba(34,211,238,0.10), transparent 55%),' +
            'linear-gradient(180deg, #0f0a1a 0%, #0a0612 45%, #030303 100%)',
        }}
        borderRight="1px solid"
        borderColor="rgba(167,139,250,0.12)"
        boxShadow="4px 0 32px rgba(0,0,0,0.5), inset -1px 0 0 rgba(255,255,255,0.04)"
      >
        <ModularSideBar />
      </Box>
      <Box flex="1" background={'#F1EFEE'} overflowY="auto" height="100%">
        <Outlet />
      </Box>
      {/* AI Act notice — one-shot per device, blocks the layout until acknowledged.
          Covers every authenticated route, not just the Blot module. */}
      <AIActNotice />
      {/* Legal consent gate — re-prompts when the accepted CGU/CGV/confidentialité
          version is older than the current LEGAL_VERSION. */}
      <LegalConsentNotice />
    </Box>
  )
}
